"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIDSettingsT = exports.HIDSettings = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
class HIDSettings {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsHIDSettings(bb, obj) {
        return (obj || new HIDSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsHIDSettings(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new HIDSettings()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    trackersOverHid() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startHIDSettings(builder) {
        builder.startObject(1);
    }
    static addTrackersOverHid(builder, trackersOverHid) {
        builder.addFieldInt8(0, +trackersOverHid, +false);
    }
    static endHIDSettings(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createHIDSettings(builder, trackersOverHid) {
        HIDSettings.startHIDSettings(builder);
        HIDSettings.addTrackersOverHid(builder, trackersOverHid);
        return HIDSettings.endHIDSettings(builder);
    }
    unpack() {
        return new HIDSettingsT(this.trackersOverHid());
    }
    unpackTo(_o) {
        _o.trackersOverHid = this.trackersOverHid();
    }
}
exports.HIDSettings = HIDSettings;
class HIDSettingsT {
    constructor(trackersOverHid = false) {
        this.trackersOverHid = trackersOverHid;
    }
    pack(builder) {
        return HIDSettings.createHIDSettings(builder, this.trackersOverHid);
    }
}
exports.HIDSettingsT = HIDSettingsT;
